import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SelectedTreeNodeKeys, AvatarsFormatted } from '../../../../../constants/constants';

interface IInitailState {
    type: SelectedTreeNodeKeys;
    formattedType: string;
}

const defaultType = `All${AvatarsFormatted.Robot}` as SelectedTreeNodeKeys;

const initialState: IInitailState = {
    type: defaultType,
    formattedType: 'Robot',
};

const avatarTypeSlice = createSlice({
    name: 'avatarType',
    initialState,
    reducers: {
        setAvatarType: (state: IInitailState, action: PayloadAction<string>) => {
            (state.type = `All${action.payload}` as SelectedTreeNodeKeys), (state.formattedType = action.payload);
        },
        cleanAvatarType: (state: IInitailState) => {
            state.type = defaultType;
            state.formattedType = '';
        },
    },
});

export default avatarTypeSlice.reducer;
export const { setAvatarType, cleanAvatarType } = avatarTypeSlice.actions;
